import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Mic, Library, Settings as SettingsIcon } from 'lucide-react';

interface MobileLayoutProps {
  children: React.ReactNode;
  showNav?: boolean;
}

export const MobileLayout: React.FC<MobileLayoutProps> = ({ children, showNav = true }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/record', icon: Mic, label: 'Record' },
    { path: '/library', icon: Library, label: 'Library' },
    { path: '/settings', icon: SettingsIcon, label: 'Settings' }
  ];

  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-slate-900 to-purple-900">
      {/* Main Content */}
      <div className={showNav ? 'pb-16' : ''}>
        {children}
      </div>

      {/* Bottom Navigation */}
      {showNav && (
        <nav className="fixed bottom-0 left-0 right-0 bg-black/80 backdrop-blur-lg border-t border-white/10">
          <div className="flex items-center justify-around py-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);
              
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`flex flex-col items-center justify-center py-2 px-4 rounded-lg transition-all ${
                    active 
                      ? 'text-purple-400' 
                      : 'text-gray-400 hover:text-gray-300'
                  }`}
                >
                  <Icon className={`w-6 h-6 ${active ? 'scale-110' : ''}`} />
                  <span className="text-xs mt-1">{item.label}</span>
                  {active && (
                    <div className="absolute bottom-0 w-12 h-0.5 bg-purple-400 rounded-full" />
                  )}
                </button>
              );
            })}
          </div>
        </nav>
      )}
    </div>
  );
};